import React from 'react'
import ListViewItem from './ListViewItem'

class ItemsListView extends React.Component{

  render() {
    return(
      <div>
        {this.props.data.map((record, i) => {
          return (<ListViewItem
            key={record.id}
            data={record}
            index={i}
            handleOnClick={this.props.handleOnClick}
            item_link={this.props.item_link}
          />)
        })}
      </div>
    )
  }

}

export default ItemsListView
